import { create } from 'zustand';
import { ImoduleFilter, ISortFilter, SORT_ORDER } from 'types/global';
import { IProductList } from 'types/orders';

interface IState {
  sortFilter: ISortFilter;
  setSortFilter: (sortFilter: ISortFilter) => void;
  orderFilters: ImoduleFilter[];
  setOrderFilters: (orderFilters: ImoduleFilter[]) => void;
  listOrdersOperations: IProductList[];
  setListOrdersOperations: (listOrdersOperations: IProductList[]) => void;
  resetOrdersOperationsState: () => void;
}

/**
 * Hook de Zustand para manejar el estado del módulo de operaciones de órdenes.
 * Gestiona filtros, ordenamiento y lista de órdenes para la vista de operaciones.
 */
const useOrdersOperationsModule = create<IState>(set => ({
  sortFilter: { value: SORT_ORDER.DESC },
  setSortFilter: (sortFilter: ISortFilter) => set({ sortFilter }),
  orderFilters: [],
  setOrderFilters: (orderFilters: ImoduleFilter[]) => set({ orderFilters }),
  listOrdersOperations: [],
  setListOrdersOperations: (listOrdersOperations: IProductList[]) => set({ listOrdersOperations }),
  resetOrdersOperationsState: () => {
    set({
      sortFilter: { value: SORT_ORDER.DESC },
      orderFilters: [],
      listOrdersOperations: []
    });
  }
}));

export default useOrdersOperationsModule;
